module.exports = __webpack_public_path__ + "static/media/isolate.2c2e73db.svg";